import {PlaylistType} from '../../backend/enums/playlist-type';
import {translations} from '../../i18n/translations';

/**
 * Array with the available playlist types in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(playlistTypes[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const playlistTypes: Array<{translation: string; type: PlaylistType}> = [
  {translation: translations.playlist_types[PlaylistType.Karaoke], type: PlaylistType.Karaoke},
  {translation: translations.playlist_types[PlaylistType.Movies], type: PlaylistType.Movies},
  {
    translation: translations.playlist_types[PlaylistType.Music],
    type: PlaylistType.Music,
  },
];
